import { render, staticRenderFns } from "./AdminProjectsList.vue?vue&type=template&id=5eb9eaea&scoped=true"
import script from "./AdminProjectsList.vue?vue&type=script&lang=js"
export * from "./AdminProjectsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb9eaea",
  null
  
)

export default component.exports